// src/queries/esimBulk/useUpdateHistoriesCount.ts

import { useQuery } from '@tanstack/react-query';

import { getUpdateHistoriesCount } from '@apis/esimBulk/update';

/**
 * useUpdateHistoriesCount
 *
 * Returns the total number of bulk update history records.
 * Used for pagination and list toolbar total count.
 */
export const useUpdateHistoriesCount = () => {
  return useQuery<number, Error>({
    queryKey: ['updateHistoriesCount'],
    queryFn: getUpdateHistoriesCount,
  });
};
